import React from "react"
import {Email} from "../access-login/style"
import SimpleAction from "../action"
import Translate from "../translate"
import {AccessUserType} from "../../types/accessUser"
import OpenWebmailButtons from "../open-webmail-buttons"

interface PropsType {
  userType: AccessUserType
  email: string
  showLoginForm: () => void
}

const AccessLostPasswordDone: React.FC<PropsType> = ({
  showLoginForm,
  email,
  userType
}: PropsType) => {
  return (
    <div>
      <Email>{email}</Email>
      <button onClick={showLoginForm} className="button-unstyled full-width">
        <SimpleAction
          fullWidth
          size={SimpleAction.sizes.large}
          variant={
            userType === AccessUserType.Candidate
              ? SimpleAction.variants.blueGlickonNoHover
              : userType === AccessUserType.Employee
              ? SimpleAction.variants.lightblueGlickon
              : SimpleAction.variants.dark
          }
        >
          <Translate label={`form-${userType}-back-to-login`} />
        </SimpleAction>
      </button>

      <OpenWebmailButtons
        withoutDescription={userType === AccessUserType.Corporate}
      />
    </div>
  )
}
export default AccessLostPasswordDone
